import DocumentTemplateHistory from './DocumentTemplateHistory';

export default DocumentTemplateHistory;
